import { Route } from '@angular/router';
import { RoutePath } from '@univacity/shared/types';
import { visaInfoResolver } from './resolvers/visa-info.resolver';

export const visaRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    data: { transparent: true, transparentColor: 'white', fullWidth: true },
    loadComponent: () =>
      import('./visa-home/visa-home.component').then(
        (m) => m.VisaHomeComponent
      ),
  },
  {
    path: `${RoutePath.checkout}`,
    resolve: { visaInfo: visaInfoResolver },
    loadComponent: () =>
      import(
        './visa-checkout/visa-checkout-page/visa-checkout-page.component'
      ).then((m) => m.VisaCheckoutPageComponent),
  },

  {
    path: `:citizen/:destination`,
    loadComponent: () =>
      import('./detail-page/visa-detail-page/visa-detail-page.component').then(
        (m) => m.VisaDetailPageComponent
      ),
  },
  // {
  //   path: `:country`,
  //   loadComponent: () =>
  //     import('./detail-page/visa-detail-page/visa-detail-page.component').then(
  //       (m) => m.VisaDetailPageComponent
  //     ),
  // },
];
